import { BASTINGS, BASTING_TYPES, MARKET } from '@nandosaus/constants';
import { BastingSelector } from '@components/basting-selector';
import { useField } from 'formik';
import { forwardRef } from 'react';
import { useMarket } from '@hooks/use-market';
import { BastingFireAnimation } from '@components/basting-selector/BastingFireAnimation';
import { Section, ErrorMessage, InactiveError } from '../../ui';
import { QuestionHeader } from '../components';

export const SelectBasting = forwardRef((props, ref) => {
  const market = useMarket();
  const validateBasting = basting => (basting ? undefined : 'Required');
  const [field, meta, helper] = useField({ name: 'basting', validate: validateBasting });
  const { setValue, setTouched } = helper;
  const { value } = field;
  const { error, touched } = meta;
  const bastingOptionsList = Object.values(BASTING_TYPES).map(bastingValue => {
    if (bastingValue === BASTING_TYPES.PLAIN) {
      return {
        value: bastingValue,
        label: BASTINGS[bastingValue].name[market === MARKET.AUSTRALIA ? 'au' : 'nz'],
      };
    }
    return {
      value: bastingValue,
      label: BASTINGS[bastingValue].name,
    };
  });

  return (
    <Section ref={ref} pb="10px">
      <BastingFireAnimation
        mx={32}
        my={32}
        selectedOptions={value ? [bastingOptionsList.find(opt => opt.value === value)?.label].filter(Boolean) : []}
      />
      <QuestionHeader
        title="Pick your heat"
        description="This will apply to all items. But don’t worry, you can change it later."
        required
      />
      {touched && !error && <InactiveError>Looks good!</InactiveError>}
      {error && touched && <ErrorMessage>{error}</ErrorMessage>}
      <BastingSelector
        bastingOptions={bastingOptionsList}
        onChange={basting => {
          setTouched(true, false);
          setValue(basting);
        }}
        selectedOptions={[value]}
      />
    </Section>
  );
});
